//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQInput from "@/components/Generics/AQInput/AQInput.vue";

/**
     * SLOTS :
     * slotIcon - add custom content before (reverseSearchIcon = false) / after (reverseSearchIcon = true) input value
     */

export default {
    name: "QFabricSearch",
    components: {
        AQInput
    },
    props: {
        disable: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        value: { type: [String, Number], default: "" },
        autofocus: { type: Boolean, default: false },
        debounce: { type: Number, default: 600 },
        error: { type: Boolean, default: false },
        errorLabel: { type: String, default: "" },
        label: { type: String, default: "" },
        placeholder: { type: String, default: "" },
        hasAppend: { type: Boolean, default: false },
        reverseSearchIcon: { type: Boolean, default: false },
        hasNormalState: { type: Boolean, default: false }, // prop used for disable state, to look normal, but disabled
        loading: { type: Boolean, default: false },
        noLabel: { type: Boolean, default: false }
    },
    data() {
        return {};
    },
    methods: {
        setValue(newVal) {
            this.$emit("input", newVal);
        },
        blurEvt(ev) {
            this.$emit("blur", ev);
        },
        focusEvt(ev) {
            this.$emit("focus", ev);
        },
        clearEvt(ev) {
            this.$emit("clear", ev);
        },
        changeEvt(ev) {
            this.$emit("change", ev);
        },
        clickEvt(ev) {
            this.$emit("click", ev);
        },
        keyDownEvt(ev) {
            this.$emit("keyDown", ev);
        },
        keyUpEvt(ev) {
            this.$emit("keyUp", ev);
        },
        keyUpEnterEvt(ev) {
            this.$emit("keyUpEnter", ev);
        }
    }
};
